<template>
<div id="dashboard-page">
    <b-card class="mb-5">
        <b-row>
            <b-col md="10">
                <h3>Purchase Requisition</h3>
                <b-breadcrumb>
                    <b-breadcrumb-item><router-link to="/dashboard/">Dashboard</router-link></b-breadcrumb-item>
                    <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
                </b-breadcrumb>
            </b-col>
            <b-col md="2 mt-3">
                <b-button v-b-tooltip.hover.top title="Download to Excel" @click="doExportToExcel" variant="info" class="mb-2 btn-download float-right"><font-awesome-icon icon="download"/></b-button>
            </b-col>
        </b-row>
        <div class="border-bottom mb-2"></div>
        <b-form v-on:submit.prevent="doFilter">
            <b-row>
                <b-col md="12">
                    <b-row class="mt-2 mb-2">
                        <b-col md="2 mb-2">
                            <b-form-input placeholder="Requested By" v-model="tableFilter.search_name"/>
                        </b-col>
                        <b-col md="2 mb-2">
                            <date-picker v-model="tableFilter.date" type="date" range placeholder="Date Range"></date-picker>
                        </b-col>
                        <b-col md="2 mb-2">
                            <b-form-input placeholder="Price" type="number" v-model="tableFilter.greater_than"/>
                        </b-col>
                        <b-col md="2 mb-2">
                            <b-form-select v-model="tableFilter.statusPurchaseRequisition" :options="statusList" />
                        </b-col>
                        <b-col md="4">
                            <button type="submit" class="mb-2 ml-2 btn btn-primary float-right" id="btn-search"><font-awesome-icon icon="search"/> Filter</button>
                            <button @click="clearFilter()" class="ml-0 btn btn-outline-primary float-right" id="btn-search"><font-awesome-icon icon="times-circle"/> Clear Filter</button>
                        </b-col>
                    </b-row>
                    <!-- <b-row>
                        <b-col md="12 mt-1 mb-4">
                            <button type="submit" class="ml-2 btn btn-primary float-right" id="btn-search"><font-awesome-icon icon="search"/> Search</button>
                            <button @click="clearFilter()" class="btn btn-danger float-right" id="btn-search"><font-awesome-icon icon="times-circle"/> Clear Search</button>
                        </b-col>
                    </b-row> -->
                </b-col>
            </b-row>
        </b-form>
        <paginated-table ref="dataTable" :can-delete="false" :can-edit="false" :can-approve="false" :can-reject="false" :data-url="apiUrl.purchaseRequisition" :data-key="dataKey" :data-columns="columns" :data-params="['search_name', 'greater_than', 'start_date', 'end_date', 'requested_by', 'status']">
        </paginated-table>
    </b-card>
</div>
</template>
<script>
    import PaginatedTable from '@/components/PaginatedTable'
    import DatePicker from 'vue2-datepicker'
    import 'vue2-datepicker/index.css'
    import Typeahead from '@/components/Typeahead'
    export default {
        name: 'purchase-requisition',
        components: {
            PaginatedTable,
            DatePicker,
            Typeahead
        },
        data () {
            return {
                dataKey: 'purchase_requisition',
                apiUrl: {
                    purchaseRequisition: window.AppConfig.apiUrl + 'purchase-requisition',
                    exportPR: window.AppConfig.apiUrl + 'export-purchase-requisition-general'
                },
                statusList: [
                    {
                        value: null,
                        text: 'Status'
                    },
                    {
                        value: 'Requested',
                        text: 'Requested'
                    },
                    {
                        value: 'Approved',
                        text: 'Approved'
                    },
                    {
                        value: 'Rejected',
                        text: 'Rejected'
                    },
                    {
                        value: 'Canceled',
                        text: 'Canceled'
                    }
                ],
                columns: [
                    {
                        key: 'requestedBy',
                        label: 'Requested By',
                        sortable: true
                    },
                    {
                        key: 'createdAt',
                        label: 'Created',
                        sortable: true
                    },
                    // {
                    //     key: 'name',
                    //     label: 'Item Name',
                    //     sortable: true
                    // },
                    {
                        key: 'price',
                        label: 'Price',
                        sortable: true
                    },
                    {
                        key: 'note',
                        label: 'Note'
                    },
                    {
                        key: 'statusPR',
                        label: 'Status'
                    },
                    {
                        key: 'actions',
                        label: ''
                    }
                ],
                tableFilter: {
                    search_name: this.$route.query.search_name,
                    greater_than: this.$route.query.greater_than,
                    status: this.$route.query.status,
                    statusPurchaseRequisition: null,
                    requested_by: this.$route.query.requested_by,
                    approved_by: this.$route.query.approved_by,
                    rejected_by: this.$route.query.rejected_by,
                    date: null,
                    start_date: this.$route.query.start_date,
                    end_date: this.$route.query.end_date,
                    userRequestedBy: {
                        value: null
                    },
                    userApprovedBy: {
                        value: null
                    },
                    userRejectedBy: {
                        value: null
                    }
                }
            }
        },
        methods: {
            doFilter () {
                this.tableFilter.status = this.tableFilter.statusPurchaseRequisition
                this.tableFilter.start_date = this.tableFilter.date !== null ? this.$moment(this.tableFilter.date[0]).format('YYYY-MM-DD') : null
                this.tableFilter.end_date = this.tableFilter.date !== null ? this.$moment(this.tableFilter.date[1]).format('YYYY-MM-DD') : null
                this.$refs.dataTable.doFilter(this.tableFilter)
            },
            clearFilter () {
                this.tableFilter.statusPurchaseRequisition = null
                this.tableFilter.greater_than = null
                this.tableFilter.search_name = null
                this.tableFilter.date = null
                this.$refs.dataTable.doFilter(this.tableFilter)
            },
            doExportToExcel () {
              let url = this.apiUrl.exportPR + '?token=' + this.$store.getters['account/tokens'].access_token
              if (this.tableFilter.requested_by !== undefined && this.tableFilter.requested_by !== null) {
                url += '&requested_by=' + this.tableFilter.requested_by
              }
              if (this.tableFilter.search_name !== undefined && this.tableFilter.search_name !== null) {
                url += '&search_name=' + this.tableFilter.search_name
              }
              if (this.tableFilter.greater_than !== undefined && this.tableFilter.greater_than !== null) {
                url += '&greater_than=' + this.tableFilter.greater_than
              }
              if (this.tableFilter.status !== undefined && this.tableFilter.status !== null) {
                url += '&status=' + this.tableFilter.status
              }
              if (this.tableFilter.price !== undefined && this.tableFilter.price !== null) {
                url += '&price=' + this.tableFilter.price
              }
              if (this.tableFilter.date !== null) {
                url += '&start_date=' + this.$moment(this.tableFilter.date[0]).format('YYYY-MM-DD') + '&end_date=' + this.$moment(this.tableFilter.date[1]).format('YYYY-MM-DD')
              }
              window.open(url)
            },
            getDateTime (value) {
                if (value !== null) {
                    return this.$moment(value).format('YYYY-MM-DD HH:mm')
                } else {
                    return '-'
                }
            }
        }
    }
</script>